import axios from 'axios'
import Sockette from 'sockette'

const backendHostPort = (process.env.REACT_APP_BACKEND_HOST_PORT)
    ? process.env.REACT_APP_BACKEND_HOST_PORT
    : `${window.location.host}`

console.log("backendHostPort from config: " + backendHostPort);

export const webGateway = axios.create({
    baseURL: `${window.location.protocol}//${backendHostPort}`
})

export const send = (methodName, value) => {
    return webGateway.get(
        'append', {
        params: {
            contentWriter: 'MethodWriter',
            methodName,
            value: (
                typeof value === 'string' || value === undefined ? value
                : JSON.stringify(value)
            )
        }
    })
}

export const getUniqueToken = () => webGateway.get('uniqueToken')

export const getAllFixFields = () => webGateway.get(`/getAllFixFields`)

export const applyRoutingRules = (rules, onSuccess, onError) => {
    return send('routingRules',
        rules.map(rule => ({
            '@RoutingRule': {
                ...rule,
                id: undefined
            }
        }))
    )
    .then(onSuccess)
    .catch(onError)
}

export const fetchConfig = () => webGateway.get('config')

export const getFixConfig = () => send('sendFixConfig')

export const getClassesOptions = (className) => webGateway.get(`classesImplementingType?type=${className}`)

export const fetchSearch = (props) => {
    const {
        transId,
        primaryQuery,
        secondaryQuery,
        curSessionId,
        order,
        fromSequenceNumber,
        toSequenceNumber,
        limit
    } = props

    const sequenceNumberQuery = 
        and(
            fromSequenceNumber !== -1 ? `@seqNumber >= ${fromSequenceNumber}` : '',
            toSequenceNumber !== -1 ? `@seqNumber <= ${toSequenceNumber}` : ''
        )

    const query = and(primaryQuery, secondaryQuery, sequenceNumberQuery)

    const searchRequest = {
        "@FixSearch": {
            "transactionId": transId,
            "projection": [],
            "query": query,
            "sessionId": curSessionId,
            "limit": limit,
            "order": { "@Order": order }
        }
    }

    return send('fixSearch', searchRequest)
}

const and = (...queryParts) => 
    queryParts
        .filter(part => !!part)
        .map(part => `(${part})`)
        .join(" and ")
    
export const jsonToYaml = (json, clazz) => {
    const data = new FormData()
    data.set('msg', json)
    if (clazz) {
        data.set('clazz', clazz)
    }    
    return webGateway.post('jsonToYaml', data)
}
export const yamlToJson = (yaml, clazz) => {
    const data = new FormData()
    data.set('msg', yaml)
    if (clazz) {
        data.set('clazz', clazz)
    }
    return webGateway.post('yamlToJson', data)
}

export const startDemo = () => webGateway.post('startDemo')

var isReconnecting = false

export const createWs = ({ handleMessage, onOpen, onClose }) => {
    const timeout = 5e3
     const ws = new Sockette(`${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${backendHostPort}/ws`, {
        timeout: timeout,
        onopen: () => {
            isReconnecting = false
            console.log("Successfully reconnected!")
            onOpen(ws)
        },
        onmessage: (e) => handleMessage(e.data),
        onreconnect: (e) => console.log('Reconnecting...', e),
        onmaximum: (e) => console.log('Stop Attempting!', e),
        onclose: (e) => {
            console.log('Closed!', e)
            onClose(e)
            // Following codes are considered as graceful 'close' by sockette
            // and won't trigger a reconnect, so we need to trigger it manually.
            if ((e.code === 1000 || e.code === 1001 || e.code === 1005) && !isReconnecting) {
                isReconnecting = true
                setTimeout(ws.reconnect, timeout)
            }
        },
        onerror: (e) => console.log('Error:', e)
    })
    return ws
}